// extracted by mini-css-extract-plugin
export var content = "_oy-1";
export var fullScreen = "_oy-0";